import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { LogoutService } from '../user-repository/logout.service';
import {
  Weightlog,
  Weightlogs,
} from 'src/app/core/model/api-response/weight-log-response-model';
import { UserDataService } from '../user-repository/user-data.service';
import { User } from 'src/app/core/model/user-model';

@Injectable({
  providedIn: 'root',
})
export class WeightLogDataService {
  constructor(
    private dbService: NgxIndexedDBService,
    private logoutService: LogoutService,
    private userDataService: UserDataService
  ) {}

  public async getWeightLogs(): Promise<Weightlogs> {
    let weightlogs: Weightlog[];
    const response = await this.dbService.getAll('weightlogs').then(
      (wl) => {
        weightlogs = [];
        wl.forEach((weightlog) => {
          const w = new Weightlog(
            weightlog['weight'],
            weightlog['date'],
            weightlog['_id']
          );
          weightlogs.push(w);
        });
        const weightlogsUpdatedAt = localStorage.getItem('weightlogsUpdatedAt');
        const weightlogsModel = new Weightlogs(weightlogs, weightlogsUpdatedAt);
        return weightlogsModel;
      },
      (error) => {
        return new Weightlogs(
          [
            new Weightlog(
              89,
              new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
              '-'
            ),
          ],
          new Date(new Date().setHours(0, 0, 0, 1)).getTime().toString()
        );
      }
    );
    return Promise.resolve(response);
  }
  public async getLastWeightLog(date: number) {
    let w: Weightlog;
    const data = await this.dbService
      .getAll('weightlogs')
      .then(async (res: Weightlog[]) => {
        if (res.length > 0) {
          const mostrecent = new Date(Math.max(...res.map((e) => e.date)));
          const lastLog = res.find((e) => new Date(e['date']) <= mostrecent);
          if (lastLog) {
            w = lastLog;
          } else {
            const user: User = JSON.parse(localStorage.getItem('user'));
            if (user) {
              w = new Weightlog(user.weight, parseInt(user.createdAt), '-');
            } else {
              w = new Weightlog(
                89,
                new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
                '-'
              );
            }
          }
        } else {
          const user: User = JSON.parse(localStorage.getItem('user'));
          if (user) {
            w = new Weightlog(user.weight, parseInt(user.createdAt), '-');
          } else {
            w = new Weightlog(
              89,
              new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
              '-'
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
        // this.logoutService.logout();
        const user: User = JSON.parse(localStorage.getItem('user'));
        if (user) {
          w = new Weightlog(user.weight, parseInt(user.createdAt), '-');
        } else {
          w = new Weightlog(
            89,
            new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
            '-'
          );
        }
      });
    return w;
  }
  public async getWeightLog(date: number): Promise<Weightlog> {
    let w: Weightlog;
    const response = await this.dbService.getAll('weightlogs').then(
      (wl) => {
        const element = wl.find((e) => e['date'] <= date);

        if (element) {
          w = new Weightlog(element['weight'], element['date'], element['_id']);
        } else {
          const user: User = JSON.parse(localStorage.getItem('user'));
          if (user) {
            w = new Weightlog(user.weight, parseInt(user.createdAt), '-');
          } else {
            w = new Weightlog(
              89,
              new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
              '-'
            );
          }
        }
      },
      (error) => {
        console.log(error);
        // this.logoutService.logout();
        const user: User = JSON.parse(localStorage.getItem('user'));
        if (user) {
          w = new Weightlog(user.weight, parseInt(user.createdAt), '-');
        } else {
          w = new Weightlog(
            89,
            new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
            '-'
          );
        }
      }
    );
    return Promise.resolve(w);
  }

  public async getCustomWeightLogs(
    startDate: number,
    endDate: number
  ): Promise<Weightlogs> {
    let weightlogs: Weightlog[];
    const response = await this.dbService
      .getAllByIndex(
        'weightlogs',
        'date',
        IDBKeyRange.bound(endDate, startDate)
      )
      .then(
        (wl) => {
          weightlogs = [];
          wl.forEach((weightlog) => {
            const w = new Weightlog(
              weightlog['weight'],
              weightlog['date'],
              weightlog['_id']
            );
            weightlogs.push(w);
          });
          const weightlogsUpdatedAt = localStorage.getItem(
            'weightlogsUpdatedAt'
          );
          const weightlogsModel = new Weightlogs(
            weightlogs,
            weightlogsUpdatedAt
          );
          return weightlogsModel;
        },
        (error) => {
          const user: User = JSON.parse(localStorage.getItem('user'));
          let founded: Weightlog;
          if (user) {
            founded = new Weightlog(user.weight, parseInt(user.createdAt), '-');
          } else {
            founded = new Weightlog(
              89,
              new Date(new Date().setHours(0, 0, 0, 1)).getTime(),
              '-'
            );
          }
          return founded as Weightlog;
        }
      );
    return Promise.resolve(response) as Promise<Weightlogs>;
  }

  public async saveWeightLogs(res: Weightlog[]): Promise<boolean> {
    localStorage.setItem('weightlogsUpdatedAt', new Date().toISOString());
    await this.removeWeightLogs();
    const user = await this.userDataService.getUser();
    res.push(new Weightlog(user.weight, 0, '-'));
    if (res.length === 0) {
      return Promise.resolve(true);
    }
    res.forEach(async (weightlog) => {
      this.dbService
        .add('weightlogs', {
          weight: weightlog.weight,
          date: new Date(weightlog.date).setHours(0, 0, 1, 0),
          _id: weightlog._id,
        })
        .then(
          () => {},
          (error) => {
            console.log(error);
            this.logoutService.logout();
          }
        );
    });
  }

  public async addWeightLog(weightlog: Weightlog): Promise<boolean> {
    localStorage.setItem('weightlogsUpdatedAt', new Date().toISOString());
    const weightlogs = await this.getWeightLogs();

    await this.removeWeightLogs();

    const index = weightlogs.weightlogs.findIndex(
      (e) => e.date < weightlog.date
    );
    if (index === -1) {
      weightlogs.weightlogs.push(weightlog);
    } else {
      weightlogs.weightlogs.splice(index, 0, weightlog);
    }
    weightlogs.weightlogs.pop();

    if (!weightlog) {
      return Promise.resolve(true);
    }

    await this.saveWeightLogs(weightlogs.weightlogs);
  }

  public async updateWeightLog(weight: number, id: string): Promise<boolean> {
    localStorage.setItem('weightlogsUpdatedAt', new Date().toISOString());
    if (!id) {
      return Promise.resolve(true);
    }
    await this.dbService.getByIndex('weightlogs', '_id', id).then(
      async (w) => {
        await this.dbService
          .update('weightlogs', {
            id: w.id,
            weight: weight,
            date: w.date,
            _id: w._id,
          })
          .then(
            () => {},
            (error) => {
              console.log(error);
              this.logoutService.logout();
            }
          );
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return new Weightlog(null, null, null);
      }
    );
  }

  public async removeWeightLogs(): Promise<boolean> {
    const response = await this.dbService.clear('weightlogs').then(
      () => {
        return true;
        // Do something after clear
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return false;
      }
    );
    return Promise.resolve(response);
  }

  convertDateToMidNight(date: number): number {
    return new Date(date).setHours(0, 0, 1, 0);
  }
}
